import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import { BlockContainer, Layout, Column } from '../../Layout';
import RichText from '../../RichText';
import { EmbeddedEntryNode } from '../../RichText/Nodes';
import { Text } from '../../Text';
import { Flexbox } from '../../Flexbox';

import { Table, TableRow, Paragraph } from './styles';

import { TableProps } from '../shared';

export function ShortFormTable({
  title,
  subtitle,
  tableId,
  tableBody
}: TableProps) {
  const RICH_TEXT_OVERRIDES: RenderNode = {
    [BLOCKS.TABLE]: (_node, children) => (
      <Table className="sft-table">{children}</Table>
    ),
    [BLOCKS.TABLE_ROW]: (_node, children) => (
      <TableRow className="sft-row">{children}</TableRow>
    ),
    [BLOCKS.TABLE_CELL]: (_node, children) => (
      <div className="sft-cell">{children}</div>
    ),
    [BLOCKS.PARAGRAPH]: (_node, children) => <Paragraph>{children}</Paragraph>,
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => (
      <Flexbox margin={['contentMargin', 0]}>
        <EmbeddedEntryNode node={node} colour="darkButton">
          {children}
        </EmbeddedEntryNode>
      </Flexbox>
    )
  };

  return (
    <BlockContainer
      id={tableId!}
      data-blockid="shortFormDisclosureTable"
      data-testid="sft-section"
    >
      <Layout paddingTop={{ 0: 'l', tablet: '3xl' }}>
        <Column size={{ 0: 12, tablet: 8 }} flexDirection="column">
          {title && (
            <Text
              fontSize={{ 0: '2xl', desktop: '4xl' }}
              fontWeight="600"
              margin={['contentMargin', 0]}
            >
              {title}
            </Text>
          )}
          {subtitle && (
            <Text
              fontSize={{ 0: '2xl', desktop: '4xl' }}
              fontWeight="300"
              margin={[0, 0, 'contentMargin']}
            >
              {subtitle}
            </Text>
          )}
          <RichText data={tableBody} overrideOptions={RICH_TEXT_OVERRIDES} />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
